<template>
  <el-dialog title='权限设置' :visible.sync='dialogVisible' width='550px' center
             @close='dialogClose' :close-on-click-modal='false'>
    <div class='permissions'>
      <div class='name'>
        <span>角色名称：{{ form.name }}</span>
      </div>
      <div class='content'>
        <p>菜单权限：</p>
      </div>
      <div class='tree'>
        <el-tree
          ref='tree'
          :data='tree'
          :props='defaultProps'
          :default-checked-keys='defaultArr'
          node-key='menuId'
          @check='handleNodeClick'
          show-checkbox
          :check-strictly='true'
          :expand-on-click-node='false'
        />
      </div>
      <div class='btnContainer'>
        <el-button size='medium' class='searchBtn' @click='dialogSubmit'>确认</el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import {
    getMenuByAppRole, seAllAppMenu,
    seAllMenu,
    updateMenuByRole,
  } from '@/service/basicfile';

  export default {
    leader: 'role-new',
    data() {
      return {
        dialogTitle: '',
        dialogVisible: false,
        buttonLoading: false,
        defaultForm: {},
        form: {
          name: '',
          treeData: [],
          selectData: '',
        },
        tree: [],
        defaultProps: {
          children: 'childList',
          label: 'title',
        },
        defaultArr: [],
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      handleNodeClick(currentObj, treeStatus) {
        let selected = treeStatus.checkedKeys.indexOf(currentObj.menuId);
        if (selected !== -1) {
          this.selectedParent(currentObj);
          this.uniteChildSame(currentObj, true);
        } else {
          if (currentObj.childList.length !== 0) {
            this.uniteChildSame(currentObj, false);
          }
        }
      },
      uniteChildSame(treeList, isSelected) {
        this.$refs.tree.setChecked(treeList.menuId, isSelected);
        for (let i = 0; i < treeList.childList.length; i++) {
          this.uniteChildSame(treeList.childList[i], isSelected);
        }
      },
      selectedParent(currentObj) {
        let currentNode = this.$refs.tree.getNode(currentObj);
        if (currentNode.parent.key !== undefined) {
          this.$refs.tree.setChecked(currentNode.parent, true);
          this.selectedParent(currentNode.parent);
        }
      },
      async dialogOpen(item) {
        this.dialogVisible = true;
        this.form = {
          name: item.roleName,
          roleId: item.id,
        };
        await this.seAllMenu();
        let res = await getMenuByAppRole({ roleId: item.id });
        if (res.status !== 0) return this.$message.warning(res.message);
        this.defaultArr = [];
        if (res.data && res.data.length) {
          this.getAllIdArr(res.data);
        }
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.defaultArr);
        });
      },
      async seAllMenu() {
        const res = await seAllAppMenu();
        if (res.status !== 0) return this.$message.error(res.message);
        this.tree = res.data;
      },
      getAllIdArr(arr) {
        arr.forEach((item) => {
          if (item.menuId) this.defaultArr.push(item.menuId);
          if (item.childList.length) {
            this.getAllIdArr(item.childList);
          }
        });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      },
      async dialogSubmit() {
        let arr = [];
        arr = this.$refs.tree.getCheckedKeys()
          .concat(this.$refs.tree.getHalfCheckedKeys());
        let menuIds = arr.join(',');
        const obj = {
          roleId: this.form.roleId,
          menuIds: menuIds,
        };
        const res = await updateMenuByRole(obj);
        if (res.status !== 0) return this.$message.warning(res.message);
        this.$message.success(res.message);
        this.dialogClose();
        this.$emit('success');
      },
    },
  };
</script>

<style lang='scss' scoped>
  .permissions {
    width: 100%;

    .name {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        color: #2F1010;
      }
    }

    .content {
      p {
        color: #2F1010;
      }
    }

    .tree {
      border: 1px solid #D2D2D2;
      width: 400px;
      height: 280px;
      margin-left: 60px;
      border-radius: 5px;
      padding: 5px;
      overflow: auto;
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }
</style>
